export default {
    namespaced: true,
    state: {
        active: false,
        checked: false,
        text: '',
    },
    mutations: {
        INIT (state, config) {
            state.active = config.active;
            state.text = config.text;
        },
        SET (state, recyclable) {
            state.checked = recyclable;
        },
    }
}